import { alsApp } from '../../lib/betriebsart'
import { useTexte } from '../../texte'

/**
 * Der Knopf, der das Buch aufs Papier bringt — und der sagt, was er kann.
 *
 * **Warum es zwei Aufschriften gibt.** `window.print()` ist in einer vom
 * Home-Bildschirm gestarteten Web-App auf iOS nicht verlässlich: die
 * Druckvorschau bleibt dort hängen. Gemeldet vom iPhone, und es trifft genau
 * den Fall, in dem diese Anwendung benutzt wird. Der dokumentierte Ausweg ist,
 * die Seite **in Safari** zu öffnen — dort tut derselbe Aufruf, was er soll.
 *
 * Also nicht ein Knopf, der auf dem einen Gerät nichts tut, sondern zwei
 * Zustände mit ehrlicher Aufschrift. **Keine stille Absage** — die Regel gilt
 * hier wie überall: etwas antippen und es passiert nichts, das soll es nicht
 * geben.
 *
 * **Ein gemeinsames Bauteil für beide Bücher.** Zwei Kopien wären hier
 * besonders albern: die eine hätte den Ausweg, die andere nicht.
 */
export function Druckknopf({
  bereit,
  wartetext,
  drucktext,
}: {
  /** Solange die Seiten geholt werden, ist der Knopf zu. */
  bereit: boolean
  wartetext: string
  drucktext: string
}) {
  const t = useTexte().buch
  const imApp = alsApp()

  if (!bereit) {
    return (
      <button type="button" className="button" disabled>
        {wartetext}
      </button>
    )
  }

  if (imApp) {
    return (
      <>
        <button
          type="button"
          className="button"
          onClick={() => window.open(window.location.href, '_blank')}
        >
          {t.inSafari}
        </button>
        <p className="feld__hinweis feld__hinweis--13" style={{ margin: 0, flexBasis: '100%' }}>
          {t.inSafariHinweis}
        </p>
      </>
    )
  }

  return (
    <button type="button" className="button" onClick={() => window.print()}>
      {drucktext}
    </button>
  )
}
